<agr-page-toolbar
  [hasPrimaryAction]="true"
  [primaryActionIcon]="getPrimaryActionIcon()"
  [primaryActionText]="getPrimaryActionText()"
  (primaryAction)="addOrEditExtendedSimulation()"
  [hasSecondaryAction]="true"
  secondaryActionIcon="print"
  [secondaryActionText]="'feed-profit.detail.extended-simulation.report.print' | translate"
  (secondaryAction)="printExtendedSimulation()"
  data-test="extended-simulation"
>
  <div class="spacing--margin-all screen-only">
    <b>{{ 'feed-profit.detail.extended-simulation.summary.title' | translate }}</b>
    <p>{{ 'feed-profit.detail.extended-simulation.summary.description' | translate }}</p>
    <ng-container *ngIf="extendedSimulationData$ | async as extendedSimulationData">
      <div class="spacing--margin-top">
        <table class="fullwidth-table fixed">
          <thead>
            <tr>
              <th class="text--label text--light text--left">
                {{
                  'feed-profit.detail.extended-simulation.summary.table-headers.profit-per-average-delivered-grow-finisher'
                    | translate
                }}
              </th>
              <th class="text--label text--light text--left">
                {{
                  'feed-profit.detail.extended-simulation.summary.table-headers.piglet-price'
                    | translate
                }}
              </th>
              <th class="text--label text--light text--left">
                {{
                  'feed-profit.detail.extended-simulation.summary.table-headers.mortality-percentage'
                    | translate
                }}
              </th>
              <th class="text--label text--light text--left">
                {{
                  'feed-profit.detail.extended-simulation.summary.table-headers.feed-profit-average-present'
                    | translate
                }}
              </th>
              <th class="text--label text--light text--left">
                {{
                  'feed-profit.detail.extended-simulation.summary.table-headers.feed-profit-per-square-meter'
                    | translate
                }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <ng-container
                [ngTemplateOutlet]="summeryvalue"
                [ngTemplateOutletContext]="{
                  data: getData(
                    extendedSimulationData.extended?.feedProfitPerDeliveredGrowFinisher,
                    extendedSimulationData.comparison?.feedProfitPerDeliveredGrowFinisher
                  ),
                }"
              ></ng-container>
              <ng-container
                [ngTemplateOutlet]="summeryvalue"
                [ngTemplateOutletContext]="{
                  data: getData(
                    extendedSimulationData.extended?.pigletPrice,
                    extendedSimulationData.comparison?.pigletPrice
                  ),
                }"
              ></ng-container>
              <ng-container
                [ngTemplateOutlet]="summeryvalue"
                [ngTemplateOutletContext]="{
                  data: getData(
                    extendedSimulationData.extended?.mortalityPercentage,
                    extendedSimulationData.comparison?.mortalityPercentage
                  ),
                }"
              ></ng-container>

              <ng-container
                [ngTemplateOutlet]="summeryvalue"
                [ngTemplateOutletContext]="{
                  data: getData(
                    extendedSimulationData.extended?.finalDifferenceAveragePresentGrowFinisher,
                    extendedSimulationData.comparison?.finalDifferenceAveragePresentGrowFinisher
                  ),
                }"
              ></ng-container>

              <ng-container
                [ngTemplateOutlet]="summeryvalue"
                [ngTemplateOutletContext]="{
                  data: getData(
                    extendedSimulationData.extended?.finalDifferenceAveragePresentGrowFinisher,
                    extendedSimulationData.comparison?.finalDifferenceAveragePresentGrowFinisher
                  ),
                }"
              ></ng-container>
            </tr>
          </tbody>
        </table>
      </div>
      <mat-divider class="spacing--margin-bottom margin-inherit-divider"></mat-divider>
      <b>{{ 'feed-profit.detail.extended-simulation.summary.fertilizer.title' | translate }}</b>
      <div class="spacing--margin-top">
        <table class="fullwidth-table fixed">
          <thead>
            <tr>
              <th class="text--label text--light text--left">
                {{
                  'feed-profit.detail.extended-simulation.summary.fertilizer.table-headers.M3-fertilizer'
                    | translate
                }}
              </th>
              <th class="text--label text--light text--left">
                {{
                  'feed-profit.detail.extended-simulation.summary.fertilizer.table-headers.price'
                    | translate
                }}
              </th>
              <th class="text--label text--light text--left">
                {{
                  'feed-profit.detail.extended-simulation.summary.fertilizer.table-headers.fertilizer-cost-per-present-grow-finisher'
                    | translate
                }}
              </th>
              <th class="text--label text--light text--left">
                {{
                  'feed-profit.detail.extended-simulation.summary.fertilizer.table-headers.feedprofit-per-average-present-grow-finisher-including-fertilizer'
                    | translate
                }}
              </th>
              <th class="text--label text--light text--left">
                {{
                  'feed-profit.detail.extended-simulation.summary.fertilizer.table-headers.feedprofit-per-meter-including-fertilizer'
                    | translate
                }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <ng-container
                [ngTemplateOutlet]="summeryvalue"
                [ngTemplateOutletContext]="{
                  data: getData(
                    extendedSimulationData.extended?.squareMeterPerGrowFinisher,
                    extendedSimulationData.comparison?.squareMeterPerGrowFinisher
                  ),
                }"
              ></ng-container>
              <ng-container
                [ngTemplateOutlet]="summeryvalue"
                [ngTemplateOutletContext]="{
                  data: getData(
                    extendedSimulationData.extended?.fertilizerPricePerCubicMeter,
                    extendedSimulationData.comparison?.fertilizerPricePerCubicMeter
                  ),
                }"
              ></ng-container>
              <ng-container
                [ngTemplateOutlet]="summeryvalue"
                [ngTemplateOutletContext]="{
                  data: getData(
                    extendedSimulationData.extended?.fertilizerCostsPerGrowFinisher,
                    extendedSimulationData.comparison?.fertilizerCostsPerGrowFinisher
                  ),
                }"
              ></ng-container>
              <ng-container
                [ngTemplateOutlet]="summeryvalue"
                [ngTemplateOutletContext]="{
                  data: getData(
                    extendedSimulationData.extended?.feedProfitAverageGrowFinisherInclFertilizer,
                    extendedSimulationData.comparison?.feedProfitAverageGrowFinisherInclFertilizer
                  ),
                }"
              ></ng-container>
              <ng-container
                [ngTemplateOutlet]="summeryvalue"
                [ngTemplateOutletContext]="{
                  data: getData(
                    extendedSimulationData.extended?.feedProfitPerSquareMeterInclFertilizer,
                    extendedSimulationData.comparison?.feedProfitPerSquareMeterInclFertilizer
                  ),
                }"
              ></ng-container>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
    <span class="text--bold"></span>
    <ng-container class="spacing--margin-top" *ngIf="tableConfig$ | async as tableConfig">
      <app-extended-simulation-table [extendedSimulationData$]="extendedSimulationData$">
      </app-extended-simulation-table>
    </ng-container>
    <ng-container
      class="spacing--margin-top"
      *ngIf="currentFeedersTableConfig$ | async as currentFeedersTableConfig"
    >
      <div class="spacing--margin-top">
        <b>{{
          'feed-profit.detail.extended-simulation.feeders.current-feeders-title' | translate
        }}</b>
        <div class="notification notification-info">
          <mat-icon>info</mat-icon>
          {{
            'feed-profit.detail.extended-simulation.feeders.feeder-comparison-explanation'
              | translate
          }}
        </div>
        <agr-table
          *ngIf="(isLoading$ | async) === false"
          [emptyTitle]="'feed-profit.detail.extended-simulation.no-feeders.title' | translate"
          [emptyDescription]="
            'feed-profit.detail.extended-simulation.no-feeders.description' | translate
          "
          emptyImage="assets/images/pigs_001.jpg"
          [config]="currentFeedersTableConfig"
          data-test="extended-simulation-detailed-row"
          class="table"
        ></agr-table>
      </div>
    </ng-container>
    <ng-template #feederColumn let-row="row" let-column="column">
      <span class="text--label">{{
        getFeedersValue(row['cur' + column.id], '1.0-2', column.id)
      }}</span>
      <span class="text--label margin-left">/</span>
      <span class="text--small margin-left">{{
        getFeedersValue(row['ext' + column.id], '1.0-2', column.id)
      }}</span>
      <ng-container
        *ngIf="
          column.id !== 'Code' &&
          getSummaryDifference(row['cur' + column.id], row['ext' + column.id]) as difference
        "
      >
        <span
          class="text--small margin-left"
          [ngClass]="
            isPositive(difference) > 0
              ? 'text-color--primary-500'
              : isPositive(difference) < 0
                ? 'text-color--warn-500'
                : ''
          "
          >{{ difference }}</span
        >
        <mat-icon *ngIf="isPositive(difference) > 0" class="text-color--primary-500 text--small"
          >arrow_upward</mat-icon
        >
        <mat-icon *ngIf="isPositive(difference) < 0" class="text-color--warn-500 text--small"
          >arrow_downward</mat-icon
        >
      </ng-container>
    </ng-template>
  </div>

  <agr-print-page
    class="print-only"
    [footerText]="'feed-profit.detail.extended-simulation.title' | translate"
    [customizedLogoSrc]="
      (location$ | async)?.country === 'NL' ? '/assets/images/thinkpig_50.png' : null
    "
  >
    <app-extended-simulation-report
      [extendedSimulationData]="extendedSimulationData$ | async"
      [calculation]="calculation"
    ></app-extended-simulation-report>
  </agr-print-page>
</agr-page-toolbar>

<ng-template #summeryvalue let-data="data">
  <td>
    <span class="text--h5">{{ data.simulationVal }}</span>
    <span class="text--normal margin-left">/</span>
    <span class="text--body margin-left">{{ data.comparisonVal }}</span>
    <span
      class="text--small margin-left"
      [ngClass]="
        data.positive > 0
          ? 'text-color--primary-500'
          : data.positive < 0
            ? 'text-color--warn-500'
            : ''
      "
      >{{ data.positive > 0 ? '+' : '' }} {{ data.difference }}
      <mat-icon *ngIf="data.positive > 0" class="text-color--primary-500">arrow_upward</mat-icon>
      <mat-icon *ngIf="data.positive < 0" class="text-color--warn-500">arrow_downward</mat-icon>
    </span>
  </td>
</ng-template>
